var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatisticsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6667 17.6L56 20.0667V8H47.3333V28.0533L44.68 30.5067L42.8933 30.9467V17.3333H34.2267V33.08L29.7867 34.1733V23.9867H21.12V36.3067L18.0933 37.0533L16.68 38.12V31.9867H8.01335V44.64L5.34668 46.64V49.9733L8.01335 47.9733V55.9867H16.68V41.4667L19.2667 39.52L21.12 39.0667V56H29.7867V36.9333L34.2267 35.84V56.0133H42.8933V33.7067L45.9867 32.9467L47.3333 31.7067V56.0267H56V23.7067L58.6667 21.24V17.6133V17.6ZM10.6667 34.6667H14V40.1467L10.6667 42.6533V34.6667ZM14 53.3333H10.6667V45.9867L14 43.48V53.3333ZM23.7733 26.6667H27.1067V34.84L23.7733 35.6667V26.6667ZM27.1067 53.3333H23.7733V38.4133L27.1067 37.5867V53.3333ZM36.8933 20H40.2267V31.6L36.8933 32.4267V20ZM40.2267 53.3333H36.8933V35.1733L40.2267 34.3467V53.3333ZM50 10.6667H53.3333V22.52L50 25.6V10.68V10.6667ZM53.3333 53.3333H50V29.2267L53.3333 26.1467V53.3333Z",
    fill: "#B7B7B7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatisticsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Statistics_Icon.5fcc04a99e5dacf699c50f7e1785ba42.svg";